export const COMPARE_PLANS_LINK = 'ComparePlansLink';